import { uploadMediaProjectCloseTasks } from '@/api/media-project-close-task'
import { getMedias } from '@/api/constant'
import api from '@/config/api'

export default {
    components: {
    },
    props: {
        showUploadForm: {
            type: Boolean,
            required: true
        },
        master: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            loading: false,
            model: {
                media: 2,
                ope_type: 1,
                pay_type: null,
                csv: null
            },
            fileList: [],
            uploading: false,
            rules: {
                media: [ { required: true, message: '请选择媒体', trigger: 'change' }],
                ope_type: [ { required: true, message: '请选择操作类型', trigger: 'change' }],
                pay_type: [ { required: true, message: '请选择付费类型', trigger: 'change' }],
                csv: [ { required: true, message: '请选择表格文件', trigger: 'change' }],
            },
            isTypeDisabled: true,
            medias: [],
        }
    },
    computed: {
        opeTypeName () {
            const map = {
                1: '关停项目',
                2: '删除项目',
                3: '删除违规素材'
            }
            return map[this.model.ope_type] || ''
        },
        publicCsv () {
            const map = {
                1: api.baseUrl + `/关停广告主项目模版.csv`,
                2: api.baseUrl + `/删除广告主项目模版.csv`,
                3: api.baseUrl + `/删除广告主违规素材模版.csv`
            }
            return map[this.model.ope_type] || ''
        },
        helpTitle () {
            const map = {
                1: `仅支持csv文件格式；*注意：此操作将该广告主下面的所有项目关停，请谨慎操作！`,
                2: `仅支持csv文件格式；*注意：此操作将该广告主下面的所有项目删除，请谨慎操作！`,
                3: `仅支持csv文件格式；*注意：该违规素材可能存在于多个广告主账户中，本次操作会把这些账户中的该素材全部删除，请谨慎操作！`
            }
            return map[this.model.ope_type] || ''
        },
    },
    mounted () {
        getMedias().then(res => { this.medias = res.data.list || {}})
    },
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.upload()
            });
        },
        upload() {
            this.loading = true
            const data = new FormData()
            data.append('ope_type', this.model.ope_type)
            data.append('media', this.model.media)
            if (this.model.ope_type == 3) {
                data.append('pay_type', this.model.pay_type)
            }
            data.append('csv', this.model.csv)
            uploadMediaProjectCloseTasks(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.openNotification(res.data)
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();
            newFileList.splice(index, 1);
            this.fileList = newFileList;
        },
        beforeUpload(file) {
            this.fileList = [file];
            this.model.csv = file
            return false;
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showUploadForm', false)
        },
        openNotification(data) {
            this.$notification.open({
              message: '执行返回结果',
              description: (
                <div>
                  <div>{data.success_count}</div>
                  <div>{data.error_count}</div>
                </div>
              ),
              duration: 0,
            });
        },
    }
}
